<template>
  <ValidationObserver
    ref="form"
    v-slot="{ invalid, errors }"
    class="sign-up insicht insicht--fade-up"
    tag="form"
    @submit.prevent="onSubmit"
    novalidate
  >
    <h2
      v-if="titleText"
      v-html="titleText"
    />

    <GeneralMessage
      v-if="response.message"
      ref="message"
      :message="response.message"
      :type="response.type"
      @close="response.message = ''"
    />

    <!-- EMAIL -->
    <ValidationProvider
      class="input-wrapper"
      name="email"
      rules="required|email"
      v-slot="{ errors, invalid, validated, dirty }"
      tag="div"
      ref="registerEmail"
      :customMessages="{ required: $t('forms.errors.fieldEmpty'), email: $t('forms.errors.emailInvalid') }"
    >
      <FormInput
        type="email"
        name="email"
        autocomplete="email"
        :placeholder="$t('forms.labels.email')"
        :label="$t('forms.labels.email')"
        v-model="formData.email"
        :error="invalid && validated"
        :disabled="formLocked"
        required
      />
      <span
        class="input-error"
        v-if="invalid && validated"
        v-html="errors[0]"
      />
    </ValidationProvider>

    <Button
      type="submit"
      level="primary"
      :text="$t('newsletter.unsubscribeButton')"
      :disabled="formLocked"
    />
  </ValidationObserver>
</template>

<script>
import Vue from "vue"
import GenericMixin from '@/mixins/GenericVueMixin';
import { mapGetters } from "vuex"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormInput from "@/components/FormInput"
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'
import scrrroll from 'scrrroll';
import { switchDateFormat } from "@/utils/formatDate"
import { getUrlParams } from "@/utils/urlParams"

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		Button,
		GeneralMessage,
	},
	props: {
		confirm: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			formData: {
				email: '',
			},
      confirmUrl: this.$root.options.confirmUrl || this.confirm,
      titleText: this.$root.options.title || this.title,
			response: {
				type: 'info',
				message: '',
			},
		}
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		formLocked() {
			return this.loading;
		},
	},
  watch: {
    isLoggedIn() {
      this.prefillForm()
    }
  },
	methods: {
		async onSubmit() {
			const isValid = await this.$refs.form.validate()
			if (isValid) {
				this.loading = true;
				document.activeElement.blur();
        this.response.message = '';
				try {
					const response = await this.$store.dispatch('unsubscribeNewsletter', this.formData)
					this.resetForm();
          this.$emit('subscribed');
          return this.$store.dispatch('redirect', {
						name: 'custom',
						url: this.confirmUrl
					})
				} catch(err) {
					const data = err.response.data;

					if (data?.errors) {
            const errors = Object.entries(data.errors).reduce((e, [k, v]) => {
              return {
                ...e,
                [k]: v.join()
              }
            }, {})
            this.$refs.form.setErrors(errors)
            await this.$nextTick();
            const inputError = this.$refs.form.$el.querySelector('.input-error');

            if (inputError) {
              scrrroll.to(inputError.parentNode)
            }
					} else {
					  this.response.message = this.$t('forms.errors.generic');
            this.response.type = 'error';
            await this.$nextTick()
            this.$refs.message.scrollTo();
          }
				}
				this.loading = false;
			} else {
				await this.$nextTick();
				const inputError = this.$refs.form.$el.querySelector('.input-error');

				if (inputError) {
					scrrroll.to(inputError.parentNode)
				}
			}
		},
		resetForm() {
			try {
        this.formData.email = '';
        this.response.message = '';
        this.$refs.form.reset();
        this.loading = false;
        document.activeElement.blur();
			}
			catch(err) {}
		},
    prefillForm() {
      if (this.accountUserDetail) {
        Object.keys(this.formData).forEach(key => {
          if (this.accountUserDetail[key] !== undefined && !this.formData[key]) {
            let value = this.accountUserDetail[key]
            if (key === 'birthday') {
              value = switchDateFormat(value, '.')
            }
            Vue.set(this.formData, key, value);
          }
        });
      }
    }
	},
  mounted() {
    const params = getUrlParams()
    if (params.email) {
      this.formData.email = params.email
    }
    this.prefillForm()
  }
}
</script>
